export default __webpack_public_path__ + "static/modal04_01-sp-c422026917cb9c5f8fa027875cf50677.png";